/* global axios */

import ApiClient from './ApiClient';

class AgentStickersAPI extends ApiClient {
  constructor() {
    super('agent_stickers', { accountScoped: true });
  }

  create(file) {
    const payload = new FormData();
    payload.append('file', file);
    payload.append('name', file.name.replace(/\.[^.]+$/, ''));
    return axios.post(this.url, payload);
  }

  createFromAttachment(attachmentId) {
    return axios.post(`${this.url}/from_attachment`, {
      attachment_id: attachmentId,
    });
  }

  update(id, attributes) {
    return axios.patch(`${this.url}/${id}`, attributes);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new AgentStickersAPI();
